(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-cusweb-card-summary][data-shopify-pid]';
  var MAX_BATCH_SIZE = 48;
  var DYNAMIC_LOAD_DELAY = 350;
  var summaryCache = Object.create(null);
  var pendingRequests = Object.create(null);
  var loadScheduled = false;
  var summaryObserver = null;

  function getCuswebOrigin() {
    var script = document.querySelector('script[data-cusweb-origin]');
    return script && script.getAttribute('data-cusweb-origin')
      ? script.getAttribute('data-cusweb-origin').replace(/\/$/, '')
      : '';
  }

  function validPid(value) {
    return /^\d{1,30}$/.test(String(value || '').trim());
  }

  function clearNode(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function setText(node, value, className) {
    clearNode(node);
    var child = document.createElement('span');
    child.className = className;
    child.textContent = value;
    node.appendChild(child);
  }

  function formatSummary(summary) {
    var quantity = Number(summary && summary.minimumQuantity);
    var price = Number(summary && summary.startingPrice);
    if (!Number.isSafeInteger(quantity) || quantity <= 0 || !Number.isFinite(price) || price <= 0) {
      return null;
    }
    var currency = String(summary.currency || 'USD').toUpperCase();
    var symbol = currency === 'USD' ? '$' : currency + ' ';
    return quantity + ' Starts at ' + symbol + price.toFixed(2);
  }

  function renderSummary(node, summary) {
    var text = formatSummary(summary);
    if (!text) {
      setText(node, 'Pricing available in configurator', 'cusweb-card-summary__status');
      return;
    }
    setText(node, text, 'cusweb-card-summary__value');
  }

  function renderNodes(nodes) {
    nodes.forEach(function (node) {
      var pid = String(node.getAttribute('data-shopify-pid') || '').trim();
      node.setAttribute('data-cusweb-summary-state', 'ready');
      renderSummary(node, summaryCache[pid]);
    });
  }

  function renderPidNodes(pids) {
    var pidMap = Object.create(null);
    pids.forEach(function (pid) { pidMap[pid] = true; });
    var nodes = Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR));
    renderNodes(nodes.filter(function (node) {
      var pid = String(node.getAttribute('data-shopify-pid') || '').trim();
      return Boolean(pidMap[pid]);
    }));
  }

  function fetchBatch(origin, pids) {
    var url = origin + '/api/product/card-summaries?shopify_pids=' + encodeURIComponent(pids.join(','));
    var request = window.fetch(url, { credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('Card summary request failed');
        return response.json();
      })
      .then(function (payload) {
        if (!payload || payload.success !== true || !payload.data || typeof payload.data !== 'object') {
          throw new Error('Card summary response invalid');
        }
        pids.forEach(function (pid) { summaryCache[pid] = payload.data[pid] || null; });
      })
      .catch(function () {
        pids.forEach(function (pid) { summaryCache[pid] = null; });
      });

    pids.forEach(function (pid) { pendingRequests[pid] = request; });
    request.then(function () {
      pids.forEach(function (pid) {
        if (pendingRequests[pid] === request) delete pendingRequests[pid];
      });
      renderPidNodes(pids);
    });
    return request;
  }

  function loadSummaries() {
    var origin = getCuswebOrigin();
    var nodes = Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR));
    if (!nodes.length) return;
    if (!origin || !window.fetch) {
      renderNodes(nodes);
      return;
    }

    var immediateNodes = [];
    var newPids = [];
    nodes.forEach(function (node) {
      var pid = String(node.getAttribute('data-shopify-pid') || '').trim();
      if (!validPid(pid) || Object.prototype.hasOwnProperty.call(summaryCache, pid)) {
        immediateNodes.push(node);
      } else if (!pendingRequests[pid] && newPids.indexOf(pid) === -1) {
        newPids.push(pid);
      }
    });

    renderNodes(immediateNodes);

    var batches = [];
    for (var index = 0; index < newPids.length; index += MAX_BATCH_SIZE) {
      batches.push(newPids.slice(index, index + MAX_BATCH_SIZE));
    }

    batches.forEach(function (batch) { fetchBatch(origin, batch); });
  }

  function containsSummaryRoot(node) {
    if (!node || node.nodeType !== 1) return false;
    if (typeof node.matches === 'function' && node.matches(ROOT_SELECTOR)) return true;
    return typeof node.querySelector === 'function' && Boolean(node.querySelector(ROOT_SELECTOR));
  }

  function scheduleLoadSummaries() {
    if (loadScheduled) return;
    loadScheduled = true;
    window.setTimeout(function () {
      loadScheduled = false;
      loadSummaries();
    }, DYNAMIC_LOAD_DELAY);
  }

  function startSummaryObserver() {
    if (summaryObserver || !window.MutationObserver || !document.body) return;
    summaryObserver = new window.MutationObserver(function (mutations) {
      for (var mutationIndex = 0; mutationIndex < mutations.length; mutationIndex += 1) {
        var addedNodes = mutations[mutationIndex].addedNodes || [];
        for (var nodeIndex = 0; nodeIndex < addedNodes.length; nodeIndex += 1) {
          if (containsSummaryRoot(addedNodes[nodeIndex])) {
            scheduleLoadSummaries();
            return;
          }
        }
      }
    });
    summaryObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    startSummaryObserver();
    loadSummaries();
  });
  document.addEventListener('shopify:section:load', loadSummaries);
  startSummaryObserver();
}());
